import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthStore } from '../../features/auth/store/auth.store';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    private router = inject(Router);
    private authStore = inject(AuthStore);

    canActivate(): boolean {
        if (this.authStore.token()) {
            return true;
        } else {
            this.router.navigate(['/login']);
            return false;
        }
    }
}
